import PropTypes from "prop-types";
import "./StopoverSidePanel.scss";
import { memo } from "react";
import { Button } from "app/components/ui/Button/Button";
import { FormattedMessage } from "react-intl";
import QuotationFlightsContainer from "app/pages/Booking/Quotation/Flight/QuotationFlightsContainer";
import StopoverDurationsContainer from "app/pages/Stopover/StopoverDurations/StopoverDurationsContainer";
import FlightsAndOptionsSkeleton from "app/pages/Booking/Quotation/Skeletons/FlightsAndOptionsSkeleton";
import { Form, Formik } from "formik";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import { useAnalytics } from "app/utils/analytics/useAnalytics";
import { Drawer } from "app/components/ui/drawer/Drawer";
import IconClose from "app/pages/.shared/IconClose";

const StopoverSidePanel = ({
	open,
	onOpenChange,
	handleCloseSelectedflightRecap = () => {},
	onDurationChange = () => {},
	handleSubmit = () => {},
	isLoading,
	formInitialValues = {},
}) => {
	const { track } = useAnalytics();

	const handleCTAClick = () => {
		handleCloseSelectedflightRecap();
		track("stopover_sidepanel_cta_clicked");
	};

	const handleCloseButtonClick = () => {
		handleCloseSelectedflightRecap();
		track("stopover_sidepanel_close_button_clicked");
	};

	return (
		<Drawer.Root open={open} onOpenChange={onOpenChange} maxSize={640}>
			<Drawer.Content>
				<Drawer.Header showClose={false}>
					<Typography variant={TYPOGRAPHY_VARIANTS.XL} component="h2" isBold>
						<FormattedMessage id="stopover.preferences.overlay.title" />
					</Typography>

					<Drawer.Close asChild>
						<Button
							variant="borderless"
							size="icon-lg"
							startIcon={<IconClose width={20} height={20} />}
							onClick={handleCloseButtonClick}
							className="stopover-side-panel__close-button"
						/>
					</Drawer.Close>
				</Drawer.Header>

				<Drawer.Body className="stopover-side-panel__body">
					<Formik
						initialValues={formInitialValues}
						onSubmit={handleSubmit}
						enableReinitialize
					>
						<Form className="stopover-side-panel__form">
							<StopoverDurationsContainer onChange={onDurationChange} />

							{isLoading ? (
								<FlightsAndOptionsSkeleton />
							) : (
								<QuotationFlightsContainer isStopover />
							)}
						</Form>
					</Formik>
				</Drawer.Body>

				<Drawer.Footer className="stopover-side-panel__footer">
					<Button
						variant="primary"
						size="lg"
						fullWidth
						onClick={handleCTAClick}
						loading={isLoading}
						disabled={isLoading}
					>
						<FormattedMessage id="stop.over.durations.side.panel.cta.label" />
					</Button>
				</Drawer.Footer>
			</Drawer.Content>
		</Drawer.Root>
	);
};

StopoverSidePanel.propTypes = {
	open: PropTypes.bool,
	onOpenChange: PropTypes.func,
	onDurationChange: PropTypes.func,
	handleCloseSelectedflightRecap: PropTypes.func,
	isLoading: PropTypes.bool,
	handleSubmit: PropTypes.func,
	formInitialValues: PropTypes.shape({
		duration: PropTypes.number,
		flight: PropTypes.string,
		luggage: PropTypes.object,
		transfer: PropTypes.string,
	}),
};

export default memo(StopoverSidePanel);
